<!-- =========================================================================================
    Description: xử lý link /logout
========================================================================================== -->

<template></template>
<script>
import {defineComponent, onMounted, getCurrentInstance} from 'vue';
import {useContextStore} from '@/stores/contextStore';

export default defineComponent({
  setup() {
    const {proxy} = getCurrentInstance();

    // Xóa cookie
    document.cookie
        .split('; ')
        .map(e => e.split('=')[0])
        .filter(e => e.startsWith('is_upgrading_sys_') || e.startsWith('g_environment'))
        .filter(key => {
            {
                document.cookie = key + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
            }
        });

    onMounted(() => {
      const contextStore = useContextStore();
      contextStore.logout();
    });

    return {};
  },
});
</script>
